export const parseBoxShadowString = (
  boxShadow?: string
): {
  offsetX: string | null;
  offsetY: string | null;
  blur: string | null;
  spread: string | null;
  color: string | null;
} => {
  if (!boxShadow) {
    return {
      offsetX: null,
      offsetY: null,
      blur: null,
      spread: null,
      color: null,
    };
  }

  const regex =
    /(-?\d*\.?\d+px)\s+(-?\d*\.?\d+px)\s+(-?\d*\.?\d+px)\s+(-?\d*\.?\d+px)?\s*#?([a-fA-F\d]{3,8})?/;
  const matches = boxShadow.match(regex);

  if (!matches) {
    return {
      offsetX: null,
      offsetY: null,
      blur: null,
      spread: null,
      color: null,
    };
  }

  const [, offsetX, offsetY, blur, spread, color] = matches;
  const formattedColor =
    color && !color.startsWith('#') ? `#${color}` : color || null;

  return {
    offsetX: offsetX || null,
    offsetY: offsetY || null,
    blur: blur || null,
    spread: spread || null,
    color: formattedColor || null,
  };
};
